import React, { useState, useEffect, useRef } from "react";
import { AddPopup, AttReguralizeAdd, AttReguralizeDelete, AttReguralizeUpdate, EventAdd, EventDelete, EventUpdate, Importantmessage, StarperformanceAdd, StarperformanceDelete, StarperformanceUpdate, ViewPopup } from "./HRActivitiesComponents";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { BASE_URL, IMAGE_URL } from "../../../config/axios";
import { AttachmentIcon, CustomImageModal, CustomTooltip, formatCurrencyIndian, handleErrorToast, renderDangerousHTML } from "../../CustomFunctions";
import usePermission from "../../../config/permissions";
import { PopupUpdate, PopupDelete } from "./HRActivitiesComponents";
import { formatDate, formatDateTime, formattedDateLong } from "../../Date";
import { Filter, Office } from "../../AllSvg";
import { AnnouncentAdd, AnnouncementUpdate, AnnouncementDelete, AddArrear, UpdateArrear, DeleteArrear, AddIncentive, UpdateIncentive, AddDynamicNature, UpdateDynamicNature, DeleteDynamicNature, SubmitArrearForApproval, ResubmitArrearForApproval, AddSandwichRule } from "./HRActivitiesComponents";
import { handleAllError, customSortByKey, getMonthName, ViewDynamicApprovalStatus, ViewDynamicApprovalRemarks, UserProfileModal } from "../../CustomFunctions";
import UserDefaultLogo from "../../UserDetails/UserDefaultLogo";

const AnnouncementTable = () => {
    const [annoucncementname, setAnnouncementname] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const { SUPER_ADMIN } = usePermission();

    const getAnnouncement = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/settings/informationboardAPI/`);
            const res = await axios.get(`${BASE_URL}/settings/infromtation/${sessionStorage.getItem('company_id')}/`);
            setAnnouncementname(res.data);
        } catch (err) {
            //toast Logic
            handleAllError(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        getAnnouncement();
    }, []);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">Announcement</div>
                    <div>
                        <AnnouncentAdd getAnnouncement={getAnnouncement} />
                    </div>
                </div>
                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Title</th>
                            <th className="align-center">Description</th>
                            <th className="align-center">Visible Period</th>
                            <th className="align-center">Attachment</th>
                            <th className="align-center width-10vw">Action</th>
                        </tr>
                    </thead>
                    {buffer ? <div className="spinner"></div> : //buffering logic
                        <tbody>
                            {annoucncementname.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">{formattedDateLong(i.date)}</td>
                                        <td className="align-center">{i.title}</td>
                                        <td className="align-center">{i.description}</td>
                                        <td className="align-center">{formattedDateLong(i.start_visibility)} to {formattedDateLong(i.end_visibility)}</td>
                                        <td className="align-center">
                                            {i.file ?
                                                <a href={i.file} target="_blank" rel="noreferrer">
                                                    <AttachmentIcon source={i.file} />
                                                </a>
                                                : '-No File Attached-'}
                                        </td>
                                        <td className="align-center width-5vw ">
                                            <AnnouncementUpdate
                                                i={i}
                                                getAnnouncement={getAnnouncement}
                                            />
                                            {SUPER_ADMIN &&
                                                <AnnouncementDelete
                                                    i={i}
                                                    getAnnouncement={getAnnouncement}
                                                />
                                            }
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
};

const PopUpTable = () => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [buffer, setBuffering] = useState(true);
    const [popupData, setPopupData] = useState([]);
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

    const getPopup = async () => {
        setBuffering(true);
        try {
            const fetchPopup = await axios.get(`${BASE_URL}/wfm/popupbysub_company/${toggleCompany}/`);
            setPopupData(fetchPopup.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getPopup();
    }, [toggleCompany])

    const popupSizeOptions = [
        { value: "half", label: "50% of Viewpage (50vw)" },
        { value: "three_fourth", label: "60% of Viewpage (60vw)" },
        { value: "fourth_fifth", label: "70% of Viewpage (70vw)" },
        { value: "fifth_sixth", label: "80% of Viewpage (80vw)" },
    ];

    return (
        <>


            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">
                        Popup Display
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        }

                        <AddPopup SUPER_ADMIN={SUPER_ADMIN} SUB_COMPANIES={SUB_COMPANIES} getPopup={getPopup} />
                    </div>
                </div>

                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Title </th>
                            <th className="align-center">Description</th>
                            <th className="align-center">Visible Period</th>

                            <th className="align-center">Sub Company</th>
                            <th className="align-center">Modal Size</th>
                            <th className="align-center">View Popup</th>
                            <th className="align-center">Attachments</th>
                            <th className="align-right width-5vw">Action</th>
                        </tr>
                    </thead>

                    {buffer ? <div className="spinner"></div> :

                        <tbody>
                            {popupData.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">

                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">{i?.title}</td>
                                        <td className="align-left">{renderDangerousHTML(i?.description)}</td>
                                        <td className="align-center">{formattedDateLong(i?.start_visibility)} to {formatDate(i?.end_visibility)}</td>

                                        <td className="align-center">{i?.sub_company_title}</td>
                                        <td className="align-center">
                                            {popupSizeOptions.find(opt => opt.value === i?.popup_size)?.label || i?.popup_size}
                                        </td>

                                        <td className="align-center">
                                            <ViewPopup i={i} infoflag={true} button_varient={'Eye-Name'} button_display_name={'Preview'} />
                                        </td>
                                        <td className="align-center">
                                            {i?.document ?
                                                <a href={i?.document} target="_blank" rel="noreferrer">
                                                    <AttachmentIcon source={i?.document} />
                                                </a>
                                                : '-No File Attached-'}
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">
                                                <PopupUpdate
                                                    i={i}
                                                    SUPER_ADMIN={SUPER_ADMIN}
                                                    SUB_COMPANIES={SUB_COMPANIES}
                                                    getPopup={getPopup}
                                                />
                                                <PopupDelete i={i} getPopup={getPopup} />

                                            </div>
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                        </tbody>
                    }

                </table>

                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
};



const AttendanceRegularizationLogsTable = () => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

    const [attRegularizedData, setAttRegularizedData] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [empList, setEmpList] = useState([]);

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [active, setEmployeeStatus] = useState('active');

    const getAttendanceRegLogs = async () => {
        setBuffering(true);
        try {
            const attRegularized = await axios.get(`${BASE_URL}/wfm/attregularizations-by-subcompany/${toggleCompany}/${active}/`);
            setAttRegularizedData(attRegularized.data);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setBuffering(false);
        }
    }


    const getAllEmpList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleCompany}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };


    useEffect(() => {
        getAttendanceRegLogs();
        getAllEmpList()
    }, [toggleCompany, active])


    return (
        <>


            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">
                        Attendance Reguralization
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
                            <Office />
                            <select
                                onChange={(e) => setToggleCompany(e.target.value)}
                                value={toggleCompany}
                                className="dropdown font-size-subheading"
                            >
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        }
                        {/* {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        } */}

                        <AttReguralizeAdd getAttendanceRegLogsData={getAttendanceRegLogs} SUPER_ADMIN={SUPER_ADMIN} SUB_COMPANIES={SUB_COMPANIES} />
                    </div>
                </div>

                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr No.</th>
                            <th className="align-center">Emp Code</th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Previous Status</th>
                            <th className="align-center">Updated Status</th>
                            <th className="align-center">Work Hours</th>
                            <th className="align-center">In Time</th>
                            <th className="align-center">Out Time</th>
                            <th className="align-center">Reason</th>
                            <th className="align-center">Created At</th>
                            <th className="align-center">Last Update</th>
                            <th className="align-right width-5vw">Action</th>
                        </tr>
                    </thead>

                    {buffer ? (
                        <tbody>
                            <tr>
                                <td colSpan="12" className="align-center">
                                    <div className="spinner"></div>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {attRegularizedData.length > 0 ? (
                                attRegularizedData
                                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="12"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.profilepic ? (
                                                            <img
                                                                src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.emp_name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>{i.emp_code}-{i.emp_name}</p>
                                                </td>
                                                <td className="align-center">{formattedDateLong(i?.date)}</td>

                                                {/* Previous Status */}
                                                <td className="align-center">
                                                    <div className="status-badge">
                                                        <span className="attendance-status" data-status={i?.previous_day_status}>
                                                            {i?.previous_day_status || '-'}
                                                        </span>
                                                        -
                                                        {i?.previous_attendance_status && (
                                                            <span className="attendance-status" data-status={i?.previous_attendance_status}>
                                                                {i?.previous_attendance_status}
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>

                                                {/* Updated Status */}
                                                <td className="align-center">
                                                    <div className="status-badge">
                                                        <span className="attendance-status updated" data-status={i?.updated_day_status}>
                                                            {i?.updated_day_status}
                                                        </span>
                                                        -
                                                        <span className="attendance-status updated" data-status={i?.updated_attendance_status}>
                                                            {i?.updated_attendance_status}
                                                        </span>
                                                    </div>
                                                </td>

                                                <td className="align-center">
                                                    {i?.previous_attendance_data?.work_duration !== undefined
                                                        ? `${i.previous_attendance_data.work_duration}`
                                                        : '-'
                                                    }
                                                </td>

                                                <td className="align-center">
                                                    {i?.previous_attendance_data?.in_time && i.previous_attendance_data.in_time !== '00:00:00'
                                                        ? i.previous_attendance_data.in_time
                                                        : '-'
                                                    }
                                                </td>

                                                <td className="align-center">
                                                    {i?.previous_attendance_data?.out_time && i.previous_attendance_data.out_time !== '00:00:00'
                                                        ? i.previous_attendance_data.out_time
                                                        : '-'
                                                    }
                                                </td>

                                                <td className="align-center reason-cell">
                                                    <div className="truncate-text" style={{ cursor: 'help' }} title={i?.reason}>
                                                        {i?.reason?.length > 50 ? `${i.reason.substring(0, 50)}...` : i.reason}
                                                    </div>
                                                </td>


                                                <td className="align-center">
                                                    {formatDateTime(i?.created_at).shortfull}
                                                </td>

                                                <td className="align-center">
                                                    <>
                                                        {i.updated_by &&
                                                            <>
                                                                <CustomImageModal customStyle>
                                                                    {i.updated_by_profilepic ? (
                                                                        <img
                                                                            src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                            alt="profile" className="profile-img"
                                                                        />
                                                                    ) : (
                                                                        <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                    )}
                                                                </CustomImageModal>
                                                                <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                                                                {/* At- */}
                                                            </>
                                                        }
                                                        <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                    </>
                                                </td>

                                                <td className="align-center">
                                                    <div className="flex-row">
                                                        <AttReguralizeUpdate
                                                            i={i}
                                                            SUPER_ADMIN={SUPER_ADMIN}
                                                            SUB_COMPANIES={SUB_COMPANIES}
                                                            getAttendanceRegLogsData={getAttendanceRegLogs}
                                                        />
                                                        {SUPER_ADMIN && <AttReguralizeDelete
                                                            i={i}
                                                            getAttendanceRegLogsData={getAttendanceRegLogs}
                                                        />}
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan="12" className="align-center">
                                        No attendance regularization records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>

                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
}

const Starperformancetables = () => {
    const [performancename, setPerformancename] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const getperformance = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/wfm/performance/`);
            const res = await axios.get(`${BASE_URL}/wfm/performance-by-filter/${sessionStorage.getItem('company_id')}/`);
            setPerformancename(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getperformance();
    }, []);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">Starperformance</div>
                    <div>
                        <StarperformanceAdd getperformance={getperformance} />
                    </div>
                </div>
                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Emp. Code</th>
                            <th className="align-center">Title</th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Reason for recogntion</th>
                            <th className="align-center">Recognized by</th>
                            <th className="align-center">Image reward</th>
                            <th className="align-center">Total awards</th>
                            <th className="align-center">Action</th>
                        </tr>
                    </thead>
                    {buffer ? <div className="spinner"></div> : //buffering logic
                        <tbody>
                            {performancename.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="9"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{i.emp_code}</td>
                                        <td className="align-center">{i.title}</td>
                                        <td className="align-center">{i.date}</td>
                                        <td className="align-center">{i.reason_for_recogntion}</td>
                                        <td className="align-center">{i.recognized_by}</td>

                                        <td className="align-center ">
                                            <img className="img-form width-5vw" src={i.image_reward} alt="" />
                                        </td>
                                        <td className="align-center">{i.total_awards}</td>
                                        <td className="align-right width-5vw ">
                                            <StarperformanceUpdate
                                                i={i}
                                                getperformance={getperformance}
                                            />
                                            <StarperformanceDelete
                                                i={i}
                                                getperformance={getperformance}
                                            />
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
};

const Eventtables = () => {
    const [eventename, setEventname] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

    const getevent = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/settings/eventAPI/`);
            const res = await axios.get(`${BASE_URL}/settings/event-filter/${toggleCompany}/`);
            setEventname(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getevent();
    }, [toggleCompany]);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">Event</div>
                    <div>
                        <EventAdd getevent={getevent} />
                    </div>
                </div>
                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Event image </th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Title</th>
                            <th className="align-center">Description</th>
                            <th className="align-right width-5vw">Action</th>
                        </tr>
                    </thead>
                    {buffer ? <div className="spinner"></div> : //buffering logic
                        <tbody>
                            {eventename.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">
                                            <img className="img-form width-5vw" src={i.file} alt="" />
                                        </td>
                                        <td className="align-center">{i.date}</td>
                                        <td className="align-center">{i.title}</td>
                                        <td className="align-center">{i.description}</td>
                                        <td className="align-center">
                                            <div className="flex-row ">
                                                <EventUpdate i={i} getevent={getevent} />
                                                <EventDelete i={i} getevent={getevent} />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
};

const Importantmessagetable = () => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [message, setMessagename] = useState([]);

    const getmessage = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                // `${BASE_URL}/settings/importantnotificationAPI/`
                `${BASE_URL}/settings/imformation-filter/${sessionStorage.getItem('company_id')}/`
            );
            setMessagename(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getmessage();
    }, []);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">Important message</div>
                    <div>
                        <Importantmessage getmessage={getmessage} />
                    </div>
                </div>
                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Message</th>
                            {/* <th className="align-right width-5vw">Action</th> */}
                        </tr>
                    </thead>
                    {buffer ? <div className="spinner"></div> : //buffering logic
                        <tbody>
                            {message.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">{formattedDateLong(i.date)}</td>
                                        <td className="align-center">{i.message}</td>
                                        {/* <td className="align-right width-5vw ">
                      <ImportantmessageUpdate i={i} getmessage={getmessage} />
                      <ImportantmessageDelete i={i} getmessage={getmessage} />
                    </td> */}
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
};

const Arreartable = ({ emp_code }) => {

    const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [empStatus, setempStatus] = useState('active');
    const [employee, setEmployee] = useState(emp_code || 'null');
    const [arrear, setArrear] = useState([]);

    const [buffer, setBuffering] = useState(true);
    const [approvalStatus, setApprovalStatus] = useState('null');



    const getArrear = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/arrear-filter/${toggleCompany}/${empStatus}/${employee}/${approvalStatus}/`
            );
            setArrear(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getArrear();
    }, [approvalStatus, toggleCompany]);

    const getDependentLabel = (i) => {

        if (i.nature_name == 'Amount' && i.amount !== null) {
            return `${formatCurrencyIndian(i.amount)}`;
        }


        // if (i.nature_name == 'Month' && i.start_date && i.end_date) {
        //     return `${formattedDateLong(i.start_date)} to ${formattedDateLong(i.end_date)}`;
        // }

        if (i.nature_name === 'Month' && i.start_date && i.end_date) {
            const start = new Date(i.start_date);
            const end = new Date(i.end_date);

            const sameMonthYear =
                start.getMonth() === end.getMonth() &&
                start.getFullYear() === end.getFullYear();

            const formatMonthYear = (date) =>
                date.toLocaleString('default', { month: 'long', year: 'numeric' });

            if (sameMonthYear) {
                return formatMonthYear(start);
            } else {
                return `${formatMonthYear(start)} to ${formatMonthYear(end)}`;
            }
        }

        if (i.nature_name == 'Days' && Array.isArray(i.date_list) && i.date_list.length > 0) {

            const formattedDates = i.date_list.map(d => formattedDateLong(d));

            const shortDisplay =
                formattedDates.length > 3
                    ? formattedDates.slice(0, 3).join(", ") + "..."
                    : formattedDates.join(", ");

            return shortDisplay;
        }

        return "-";
    };


    const getTooltipContent = (i) => {


        if (i.nature_name == 'Amount' && i.amount !== null) {
            return (
                <div>
                    <strong>Amount:</strong> {i.amount}
                </div>
            );
        }


        if (i.nature_name == 'Month' && i.start_date && i.end_date) {
            const start = new Date(i.start_date);
            const end = new Date(i.end_date);

            const sameMonthYear =
                start.getMonth() === end.getMonth() &&
                start.getFullYear() === end.getFullYear();

            const formatMonthYear = (date) =>
                date.toLocaleString('default', { month: 'long', year: 'numeric' });

            return (
                <div>
                    {/* <div>
                        {formattedDateLong(i.start_date)} to {formattedDateLong(i.end_date)}
                    </div> */}

                    {sameMonthYear ?
                        <div>
                            {formatMonthYear(start)}
                        </div>
                        :
                        <div>
                            {`${formatMonthYear(start)} to ${formatMonthYear(end)}`}
                        </div>
                    }
                    <div>
                        ({i.days_calculated} days)
                    </div>
                </div>
            );
        }


        if (i.nature_name == 'Days' && Array.isArray(i.date_list) && i.date_list.length > 0) {
            return (
                <div>
                    <ul style={{ paddingLeft: "18px", margin: 0, textAlign: 'left' }}>
                        {i.date_list.map((d, index) => (
                            <li key={index}>
                                {formattedDateLong(d)}
                            </li>
                        ))}
                    </ul>
                    <div style={{ marginTop: "4px" }}>
                        ({i.date_list.length} days)
                    </div>
                </div>
            );
        }

        return null;
    };


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Arrear
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN && !emp_code ? <div className="table-searchh dropdown-container field-cont-div">
                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                            </select>
                        </div> : null}

                        <div className="table-searchh dropdown-container field-cont-div">
                            <Filter />
                            <select
                                onChange={(e) => setApprovalStatus(e.target.value)}
                                value={approvalStatus}
                                className="dropdown font-size-subheading"
                            >
                                <option value="null">Select Status</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                        </div>

                        {!emp_code && (
                            <AddArrear
                                getArrear={getArrear}
                                SUB_COMPANIES={SUB_COMPANIES}
                                SUPER_ADMIN={SUPER_ADMIN}
                            />
                        )}

                    </div>
                </div>

                <div className="scroll-container-table">
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr no.</th>
                                <th className="align-center">Employee</th>
                                <th className="align-center">Nature</th>
                                <th className="align-center">Based on</th>

                                <th className="align-center">Applicable month</th>
                                <th className="align-center">Reason</th>

                                <th className="align-center">Attachment</th>
                                <th className="align-center">Status</th>
                                <th className="align-center">Approved Details</th>
                                {/* <th className="align-center">Approved amount</th>
                                <th className="align-center">Approved days</th> */}
                                <th className="align-center">Arrear Status</th>
                                <th className="align-center">Arrear Remarks</th>
                                {SUPER_ADMIN && !emp_code && <th className="align-center">Sub Company</th>}
                                <th className="align-center">Created At</th>
                                <th className="align-center">Last Update</th>
                                {PERMISSION_HR_ADMIN && <th className="align-center">Action</th>}
                            </tr>
                        </thead>

                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {arrear.length === 0 ? (
                                    <tr>
                                        <td colSpan={16} className="align-center text-gray-500">
                                            No arrear records found
                                        </td>
                                    </tr>
                                ) : (
                                    arrear.map((i, index) => {
                                        const isAmount = (i) => i.amount !== null;
                                        const isMonths = (i) => i.start_date && i.end_date;
                                        const isDays = (i) => Array.isArray(i.date_list) && i.date_list.length > 0;

                                        return (

                                            <tr key={index} className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.profilepic ? (
                                                            <img
                                                                src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.emp_name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>{i.emp_code}-{i.emp_name}</p>
                                                </td>

                                                <td className="align-center">
                                                    {i.nature_name || "-"}
                                                </td>

                                                <td
                                                    className="align-center"
                                                    style={{ cursor: 'help' }}

                                                >
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={
                                                            <div>
                                                                {getTooltipContent(i)}
                                                            </div>
                                                        }
                                                    >
                                                        {getDependentLabel(i)}
                                                    </CustomTooltip>
                                                </td>


                                                <td className="align-center" >
                                                    {getMonthName(i?.applicable_month)} {i?.applicable_year}
                                                </td>
                                                <td className="align-center">{i.reason || '-'}</td>
                                                <td className="align-center">
                                                    {i.proof ?
                                                        <a href={i.proof} target="_blank" rel="noreferrer">
                                                            <AttachmentIcon source={i.proof} />
                                                        </a>
                                                        : '-No File Attached-'}
                                                </td>

                                                <td className={`align-center request-status text-capitalize`} request-status={i.status}>
                                                    {i.status || '-'}
                                                </td>
                                                <td className="table-body width-15vw">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            {i.approved_amount &&
                                                                <tr>
                                                                    <td className="table-body">Approved Amount</td>
                                                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                    <td
                                                                        className="align-center word-wrap-20vw"
                                                                    >
                                                                        {i.approved_amount || '-'}
                                                                    </td>
                                                                </tr>

                                                            }
                                                            {i.approved_days &&
                                                                <tr>
                                                                    <td className="table-body">Approved Days</td>
                                                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                    <td
                                                                        className="align-center word-wrap-20vw"
                                                                    >
                                                                        {i.approved_days || '-'}
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </td>

                                                {/* <td className="align-center">{i.approved_amount || '-'}</td>
                                                <td className="align-center">{i.approved_days || '-'}</td> */}

                                                <ViewDynamicApprovalStatus dynamic_approval={i.dynamic_approval} />
                                                <ViewDynamicApprovalRemarks dynamic_approval={i.dynamic_approval} />

                                                {SUPER_ADMIN && !emp_code && <td className="align-center">{i.sub_company_name || '-'}</td>}
                                                <td className="table-body align-center">
                                                    {i.created_at ? (
                                                        <UserProfileModal
                                                            code={i.created_by}
                                                            name={i.created_by_name}
                                                            profilePic={i.created_by_profilepic}
                                                            dateText={formatDateTime(i.created_at).shortfull}
                                                        />
                                                    )
                                                        :
                                                        <>
                                                            {formatDateTime(i?.created_at).longdate}
                                                            <br />
                                                            <small>{formatDateTime(i?.created_at).time}</small>
                                                        </>
                                                    }
                                                </td>


                                                <td className="table-body align-center">

                                                    {i.updated_by ? (
                                                        <UserProfileModal
                                                            code={i.updated_by}
                                                            name={i.updated_by_name}
                                                            profilePic={i.updated_by_profilepic}
                                                            dateText={formatDateTime(i.updated_at).shortfull}
                                                        />
                                                    ) : (
                                                        <>
                                                            {formatDateTime(i.updated_at).longdate}
                                                            <br />
                                                            <small>{formatDateTime(i.updated_at).time}</small>
                                                        </>
                                                    )}
                                                </td>

                                                {!emp_code && (
                                                    <td className="align-center" >
                                                        <div className="flex-row ">

                                                            <UpdateArrear i={i} getArrear={getArrear}
                                                                SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN}
                                                            />
                                                            {/* {i.status === 'pending' && (
                                                            <SubmitArrearForApproval
                                                                i={i}
                                                                userData={userData}
                                                                getArrear={getArrear}
                                                            />
                                                        )} */}
                                                            {/* {i.status === 'rejected' && (
                                                            <ResubmitArrearForApproval
                                                                i={i}
                                                                userData={userData}
                                                                getArrear={getArrear}
                                                            />
                                                        )} */}

                                                            <DeleteArrear i={i} getArrear={getArrear}
                                                            />

                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        )
                                    }
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};


const Incentivetable = ({ emp_code }) => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [incentive, setIncentive] = useState([]);
    const [approvalStatus, setApprovalStatus] = useState(null)

    const getIncentive = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/incentive-details-log-by-emp/${emp_code}/${approvalStatus}/`
            );

            setIncentive(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getIncentive();
    }, []);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Incentive
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        }

                        <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setApprovalStatus(e.target.value)} value={approvalStatus} className="dropdown font-size-subheading">
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>


                            </select>
                        </div>

                        <AddIncentive getIncentive={getIncentive} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                    </div>
                </div>

                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Employee</th>
                            <th className="align-center">Amount</th>
                            <th className="align-center">Reason</th>
                            <th className="align-center">Nature</th>
                            <th className="align-center">Proof</th>
                            <th className="align-center">Date</th>
                            <th className="align-center">Approved Amount</th>
                            <th className="align-center">Status</th>
                            <th className="align-center">SubCompany</th>
                            <th className="align-center">Created At</th>
                            <th className="align-center">Last Update</th>
                        </tr>
                    </thead>

                    {buffer ? (
                        <div className="spinner"></div>
                    ) : (
                        <tbody>
                            {incentive.length === 0 ? (
                                <tr>
                                    <td colSpan={12} className="align-center text-gray-500">
                                        No incentive records found
                                    </td>
                                </tr>
                            ) : (
                                incentive.map((i, index) => (
                                    <tr key={index} className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">
                                            <CustomImageModal customStyle>
                                                {i.profilepic ? (
                                                    <img
                                                        src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                                        alt="profile" className="profile-img"
                                                    />
                                                ) : (
                                                    <UserDefaultLogo user={{ name: i.emp_name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                )}
                                            </CustomImageModal>
                                            <p>{i.emp_code}-{i.emp_name}</p>
                                        </td>

                                        <td className="align-center">{i.amount || "-"}</td>
                                        <td className="align-center">{i.reason}</td>
                                        <td className="align-center">{i.nature}</td>
                                        <td className="align-center">{i.proof}</td>
                                        <td className="align-center">{i.month_year}</td>
                                        <td className="align-center">{i.approved_amount}</td>
                                        <td className="align-center">{i.status}</td>
                                        <td className="align-center">{i.sub_company}</td>
                                        <td className="table-body align-center">
                                            <>
                                                {i.created_at &&
                                                    <>
                                                        <CustomImageModal customStyle>
                                                            {i.created_by_profilepic ? (
                                                                <img
                                                                    src={`${`${IMAGE_URL}${i.created_by_profilepic}`}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: i.created_by_name, profilepic: i.created_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p>{`${i.created_by} -`}{i.created_by_name}</p>

                                                    </>
                                                }
                                                {i.created_at ?
                                                    <small>{i?.created_at && formatDateTime(i?.created_at).shortfull}</small>
                                                    :
                                                    <>
                                                        {i?.created_at && formatDateTime(i?.created_at).longdate}
                                                        <br />
                                                        <small>{i?.created_at && formatDateTime(i?.created_at).time}</small>
                                                    </>}
                                            </>
                                        </td>


                                        <td className="table-body align-center">
                                            <>
                                                {i.updated_by &&
                                                    <>
                                                        <CustomImageModal customStyle>
                                                            {i.updated_by_profilepic ? (
                                                                <img
                                                                    src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p>{`${i.updated_by} -`}{i.updated_by_name}</p>

                                                    </>
                                                }
                                                {i.updated_by ?
                                                    <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                    :
                                                    <>
                                                        {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                                        <br />
                                                        <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                                                    </>}
                                            </>
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">

                                                <UpdateIncentive i={i} getIncentive={getIncentive}
                                                    SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    )}
                </table>
            </div>
        </>
    );
};

const DynamicNaturetable = () => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [dynamicNature, setDynamicNature] = useState([]);
    const [format, setFormat] = useState('null')


    const getDynamicNature = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamic-nature-byfilter/${toggleCompany}/${format}/`
            );
            setDynamicNature(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getDynamicNature();
    }, [toggleCompany, format]);


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Dynamic Nature
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        }

                        <div className="table-searchh dropdown-container field-cont-div">

                            <select onChange={(e) => setFormat(e.target.value)} value={format} className="dropdown font-size-subheading">
                                <option value="null">All</option>
                                <option value="incentive">Incentive</option>
                                <option value="arrear">Arrear</option>
                            </select>
                        </div>

                        <AddDynamicNature getDynamicNature={getDynamicNature} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                    </div>
                </div>

                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr no.</th>
                            <th className="align-center">Name</th>
                            <th className="align-center">Description</th>
                            <th className="align-center">Format</th>
                            <th className="align-center">Calculation Type</th>
                            <th className="align-center">SubCompany</th>
                            <th className="align-center">Created At</th>
                            <th className="align-center">Last Update</th>
                        </tr>
                    </thead>

                    {buffer ? (
                        <div className="spinner"></div>
                    ) : (
                        <tbody>
                            {dynamicNature.length === 0 ? (
                                <tr>
                                    <td colSpan={12} className="align-center text-gray-500">
                                        No incentive records found
                                    </td>
                                </tr>
                            ) : (
                                dynamicNature.map((i, index) => (
                                    <tr key={index} className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">
                                            {i?.name || '-'}
                                        </td>

                                        <td className="align-center">{i.description || "-"}</td>
                                        <td className="align-center text-capitalize">{i.format_for}</td>
                                        <td className="align-center text-capitalize">{i.calculation_type}</td>
                                        <td className="align-center">{i.sub_company_name}</td>
                                        <td className="table-body align-center">
                                            {i.created_at ? (
                                                <UserProfileModal
                                                    code={i.created_by}
                                                    name={i.created_by_name}
                                                    profilePic={i.created_by_profilepic}
                                                    dateText={formatDateTime(i.created_at).shortfull}
                                                />
                                            )
                                                :
                                                <>
                                                    {formatDateTime(i?.created_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i?.created_at).time}</small>
                                                </>
                                            }
                                        </td>


                                        <td className="table-body align-center">

                                            {i.updated_by ? (
                                                <UserProfileModal
                                                    code={i.updated_by}
                                                    name={i.updated_by_name}
                                                    profilePic={i.updated_by_profilepic}
                                                    dateText={formatDateTime(i.updated_at).shortfull}
                                                />
                                            ) : (
                                                <>
                                                    {formatDateTime(i.updated_at).longdate}
                                                    <br />
                                                    <small>{formatDateTime(i.updated_at).time}</small>
                                                </>
                                            )}
                                        </td>
                                        <td className="align-center" >
                                            <div className="flex-row ">

                                                <UpdateDynamicNature i={i} getDynamicNature={getDynamicNature} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                                                <DeleteDynamicNature i={i} getDynamicNature={getDynamicNature} />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    )}
                </table>
            </div>
        </>
    );
};

const SandwichRuleTable = () => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [sandwichruleLog, setSandwichRuleLog] = useState({});
    const [buffer, setBuffering] = useState(true);
    const getSandwichRuleLog = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `https://pp1nvg0p-8002.inc1.devtunnels.ms/wfm/sandwichrule-logs/`
            );
            setSandwichRuleLog(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getSandwichRuleLog();
    }, []);

    console.log(sandwichruleLog, "sandwichlog");

    return (
        <>


            <div className="table-css-white-background">
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500    font-size-heading">
                        Sandwich Rule
                    </div>
                    <div className="field-cont">
                        {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
                            <Office />
                            <select
                                onChange={(e) => setToggleCompany(e.target.value)}
                                value={toggleCompany}
                                className="dropdown font-size-subheading"
                            >
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                            </select>
                        </div> : null
                        }

                        <AddSandwichRule toggleCompany={toggleCompany} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                    </div>
                </div>

                <table className="table-css">
                    <thead>
                        <tr className="custom-table-head-tr">
                            <th className="align-left">Sr No.</th>

                        </tr>
                    </thead>


                </table>

                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
}

export { PopUpTable, AnnouncementTable, AttendanceRegularizationLogsTable, Starperformancetables, Eventtables, Importantmessagetable, Arreartable, Incentivetable, DynamicNaturetable, SandwichRuleTable }